import styled from 'styled-components';

export const HeroStyled = styled.section`
  padding: 48px 0 0 0;
  background-color: #212127;
  background-image: url('https://cdn.auth0.com/website/universal-login/mobile-atom-bg.svg');
  background-position: center bottom;
  background-repeat: no-repeat;
  color: white;

  @media screen and (min-width: 992px) {
    padding: 209px 0 150px;
    background-image: url('https://cdn.auth0.com/website/universal-login/hero-atoms-bg.svg');
    background-position: right calc(50% - 340px) bottom 50%;
  }
`;

export const Button = styled.a`
  width: 100%;
  display: block;

  &.white {
    box-shadow: inset 0 0 0 1px #fff;
    color: white;
    transition: all 0.2s ease;

    &:hover,
    &:focus,
    &:active {
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7);
      color: rgba(255, 255, 255, 0.7);
      transition: all 0.2s ease;
    }
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  @media screen and (min-width: 992px) {
    display: inline-block;
    width: auto;
    margin-bottom: 0;

    &:not(:last-child) {
      margin: 0 24px 0 0;
    }
  }
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  justify-content: center;

  @media screen and (min-width: 992px) {
    justify-content: flex-start;
    margin-bottom: 32px;
  }

  img {
    @media screen and (min-width: 992px) {
      margin-right: 25px;
    }
  }

  h2 {
    display: none;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 23.4px;
    color: #ffffff;

    @media screen and (min-width: 992px) {
      display: inline-block;
    }
  }
`;

export const TextHeader = styled.div`
  @media screen and (min-width: 992px) {
    grid-column: 2 / 7;
    grid-column: 2 / 8;
  }
`;

export const Headline = styled.h1`
  margin-bottom: 32px;
  font-size: 32px;
  line-height: 1.3;
  text-align: center;
  color: #ffffff;

  @media screen and (min-width: 992px) {
    margin-bottom: 64px;
    font-size: 40px;
    color: #ffffff;
    text-align: left;
  }
`;

export const ImageBlock = styled.figure`
  margin-top: 48px;
  max-height: 61vw;
  overflow: hidden;

  @media screen and (min-width: 992px) {
    grid-column: 8 / 13;
    margin-top: 0;
    max-height: initial;
    position: relative;
  }

  img {
    display: block;
    max-width: 59vw;
    margin: 0 auto;

    @media screen and (min-width: 992px) {
      max-width: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Hero/styled.js